export default __webpack_public_path__ + "static/media/viking_PNG10.42778020.png";